import React, { useEffect, useState } from "react";
import MonthlyOfferingService from "../Service/MonthlyOfferingService";
import { useLocation } from "react-router-dom";
import NominationService from "../Service/NominationService";
import { useFreezeNomination } from "../Context/FreezeNominationContext";
import MasterCourseService from "../Service/MasterCourseService";  
import { format } from "date-fns";

function SMENomination() {
  const location = useLocation();
  const { user } = location.state || {}; // Extract user from location.state
  const { isFrozen } = useFreezeNomination(); // Get isFrozen state from context

  const [error, setError] = useState(null);
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [monthlyCoursesOffered, setMonthlyCoursesOffered] = useState([]);
  const [allMonthlyCoursesOffered, setAllMonthlyCoursesOffered] = useState([]);
  const [showModal, setShowModal] = useState(false);

  // Code for pagination start
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  // Calculate current page data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentCourses = monthlyCoursesOffered.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(monthlyCoursesOffered.length / itemsPerPage);

  // Reset to Page 1 when Courses Change
  useEffect(() => {
    setCurrentPage(1);
  }, [monthlyCoursesOffered]);
  // Code for pagination end

  useEffect(() => {
    if (selectedMonth !== "") {
      fetchCoursesByMonth();
      fetchCoursesByMonth2();
    }
  }, [selectedMonth]);

  const fetchCoursesByMonth = async () => {
    try {
      const response = await MonthlyOfferingService.getAllUnnominatedCoursesBySMEWithinSelectedMonthAndTrack(
        user.userId,
        user.track,
        selectedMonth
      );

      // Add SME count for each course
      const updatedCourses = await Promise.all(
        response.map(async (course) => {
          const smeCount = await numberOfSMEsRequiredByComponentCourseId(course.componentCourseId);
          console.log("SME Count for course", course.componentCourseId, ":", smeCount);
          return { ...course, smeCount };
        })
      );

      setMonthlyCoursesOffered(updatedCourses);
      setShowTable(updatedCourses.length !== 0);
    } catch (error) {
      console.error("Error fetching courses:", error);
      setShowTable(false);
    }
  };

  const fetchCoursesByMonth2 = async () => {
    try {
      const response = await MonthlyOfferingService.getAllCoursesWithinSelectedMonthAndTrack(
        selectedMonth,
        user.track
      );
      setAllMonthlyCoursesOffered(response);
    } catch (error) {
      console.error("Error fetching all courses:", error);
    }
  };

  const numberOfSMEsRequiredByComponentCourseId = async (componentCourseId) => {
    try {
      const response = await MasterCourseService.getNumberOfSmesByComponentCourseId(componentCourseId);
      return response;
    } catch (error) {
      console.error("Error fetching SME count:", error);
      return 0;
    }
  };

  // Handle checkbox selection (only one per course)
  const handleCheckboxChange = (course, smeIndex) => {
    const key = `${course.monthlyOfferingId}-${smeIndex}`;

    setSelectedCourses((prev) => {
      const isSelected = prev.some((item) => item.key === key);
      const withoutCourse = prev.filter((item) => item.monthlyOfferingId !== course.monthlyOfferingId);

      if (isSelected) return withoutCourse; // deselect
      return [
        ...withoutCourse,
        {
          key,
          monthlyOfferingId: course.monthlyOfferingId,
          smeId: smeIndex + 1,
          userId: user.userId,
          confirmationStatus: "NOMINATED",
        },
      ];
    });
  };

  const isCourseSelected = (key) => selectedCourses.some((item) => item.key === key);


  const handleSaveNomination = async () => {
    if (selectedCourses.length === 0) {
      alert("No courses selected for nomination");
      return;
    }
    // Get current IST time
    const now = new Date();
    const istOffset = 5 * 60 + 30; // 5 hours 30 minutes in minutes
    const istTime = new Date(now.getTime() + istOffset * 60 * 1000);
    const nominationTime = istTime.toISOString();
   // Prepare nominations payload with SME slot
  const nominationsWithTime = selectedCourses.map((course) => ({
    monthlyOfferingId: course.monthlyOfferingId,
    userId: course.userId,
    confirmationStatus: course.confirmationStatus,
    smeId: `SME${course.smeId}`, 
    nominationTime,
  }));

  // Log each nomination for debugging
  console.log("Saving nominations:");
  nominationsWithTime.forEach((n) => {
    console.log(`Course ID: ${n.monthlyOfferingId}, SME Slot: ${n.smeId}`);
  });

    try {
      const response = await NominationService.saveNomination(nominationsWithTime);
      if (response === true) {
        alert("Your nomination was saved successfully");
      
        // Remove nominated courses from table
      const updatedCourses = monthlyCoursesOffered.filter(
        (course) => !selectedCourses.some((sel) => sel.monthlyOfferingId === course.monthlyOfferingId)
      );

      
        setMonthlyCoursesOffered(updatedCourses);
        setShowTable(updatedCourses.length !== 0);
      setSelectedCourses([]); // Clear selection after save
       
      }
    } catch (error) {
      setError("Failed to save nominations");
      console.error("Error saving nominations:", error);
    }
  };

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  return (
    <div className="overflow-x-auto p-6 bg-white rounded-lg shadow-md mt-4">
      <h2 className="text-2xl font-semibold mb-4" align="center">SME Nomination</h2>
      <div className="flex flex-col items-center mb-4">
      <label htmlFor="month" className="text-gray-700">Select Month</label>
        <input
          id="month"
          type="month"
          value={selectedMonth}
          onChange={(e) => setSelectedMonth(e.target.value)}
          className="w-60 px-4 py-2 border rounded-md focus:ring-2 focus:ring-purple-500"
          required
        />
      </div>

      {showTable && (
        <div className="mt-6">
         {isFrozen && (
            <p className="bg-red-200 text-red-800 p-4 rounded-lg border border-red-300">
              Nominations are frozen. Changes are not allowed.
            </p>
          )}
          <br />
          <h3 className="text-xl font-semibold mb-4">Nominate for courses</h3>

          {/* new code start */}
          <CoursesTable
            courses={currentCourses}
            handleCheckboxChange={handleCheckboxChange}
            isCourseSelected={isCourseSelected}
            showNominateColumn={true}
            isFrozen={isFrozen}
          />
         
          <div className="flex justify-center items-center mt-4 space-x-2">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className="px-3 py-1 bg-gray-300 rounded disabled:opacity-50"
            >
              Previous
            </button>
            <span>{`Page ${currentPage} of ${totalPages}`}</span>
            <button
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
              className="px-3 py-1 bg-gray-300 rounded disabled:opacity-50"
            >
              Next
            </button>
          </div>
          {/*  */}
          {/* new code end */}
          {currentPage === totalPages && (
            <div className="mt-4 flex justify-center">
              <button
                onClick={handleSaveNomination}
                className="bg-green-500 text-white px-4 py-2 rounded-md"
                disabled={isFrozen}
              >
                Save Nomination
              </button>
            </div>
          )}
        </div>
      )}

      {selectedMonth && monthlyCoursesOffered.length === 0 && allMonthlyCoursesOffered.length !== 0 && (
        <p className="text-center text-gray-700 mt-4">No learning offerings open for nomination.</p>
      )}

      {selectedMonth && allMonthlyCoursesOffered.length === 0 && (
        <p className="text-center text-gray-700 mt-4">NolLearning offerings planned for given month</p>
      )}

      {selectedMonth && allMonthlyCoursesOffered.length !== 0 && (
        <div className="mt-4 flex justify-center">
          <button
            onClick={toggleModal}
            className="bg-blue-500 text-white px-4 py-2 rounded-md"
          >
            Show All Offerings
          </button>
        </div>
      )}

      <Modal showModal={showModal} toggleModal={toggleModal} allCourses={allMonthlyCoursesOffered} />
    </div>
  );
}

const CoursesTable = ({ courses, handleCheckboxChange, isCourseSelected, showNominateColumn, isFrozen }) => (
  <table className="min-w-full bg-white border border-gray-200">
    <thead>
      <tr>
        <th className="px-4 py-2 border text-xs">Component Course</th>
        <th className="px-4 py-2 border text-xs">Mode</th>
        <th className="px-4 py-2 border text-xs">Hours</th>
        <th className="px-4 py-2 border text-xs">Days</th>
        <th className="px-4 py-2 border text-xs">Start Date</th>
        <th className="px-4 py-2 border text-xs">End Date</th>
        <th className="px-4 py-2 border text-xs">Time</th>
        <th className="px-4 py-2 border text-xs">Program</th>
        <th className="px-4 py-2 border text-xs">Comment</th>

        {/* SME Columns */}
        {showNominateColumn &&
          courses.length > 0 &&
          Array.from({ length: Math.max(...courses.map(c => c.smeCount || 0)) }, (_, i) => (
            <th key={i} className="px-4 py-2 border text-xs">SME {i + 1}</th>
          ))}
      </tr>
    </thead>
    <tbody>
      {courses.map((course) => (
        <tr key={course.monthlyOfferingId} className="border-b">
          <td className="px-4 py-2 border text-xs">{course.componentCourseName}</td>
          <td className="px-4 py-2 border text-xs">{course.modeOfLearning}</td>
          <td className="px-4 py-2 border text-xs">{course.durationInHours}</td>
          <td className="px-4 py-2 border text-xs">{course.durationInDays}</td>
          <td className="px-4 py-2 border text-xs">{format(new Date(course.startDate), "dd-MMM-yyyy")}</td>
          <td className="px-4 py-2 border text-xs">{format(new Date(course.endDate), "dd-MMM-yyyy")}</td>
          <td className="px-4 py-2 border text-xs">{course.time}</td>
          <td className="px-4 py-2 border text-xs">{course.programName}</td>
          <td className="px-4 py-2 border text-xs">{course.comment}</td>

          {showNominateColumn &&
            Array.from({ length: course.smeCount || 0 }, (_, i) => (
              <td key={i} className="px-4 py-2 border text-center text-xs">
              <input
                type="checkbox"
                disabled={isFrozen}
                checked={isCourseSelected(`${course.monthlyOfferingId}-${i}`)}
                onChange={() => handleCheckboxChange(course, i)}
              />
            </td>
            ))}
        </tr>
      ))}
    </tbody>
  </table>
);


const Modal = ({ showModal, toggleModal, allCourses }) => {
  if (!showModal) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
    <div className="bg-white p-6 rounded-lg max-w-6xl w-full overflow-hidden">
      <h3 className="text-xl font-semibold mb-4">All Monthly Courses Offered</h3>
      <div className="max-h-96 overflow-y-auto">
        <CoursesTable
          courses={allCourses}
          handleCheckboxChange={() => {}}
          isCourseSelected={() => false}
          showNominateColumn={false}
        />
        </div>
        <div className="mt-4 flex justify-center">
          <button
            onClick={toggleModal}
            className="bg-red-500 text-white px-4 py-2 rounded-md"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SMENomination;